import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    SaveComponent: {
        marginTop: '3rem',
    },
    SaveComponentButtons: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.5rem',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
        },
    },
    SaveComponentButton: {
        padding: '1rem 2rem',
        borderRadius: '1rem',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    SaveComponentButtonTypeSave: {
        background: theme.palette.primary.main,
        '&:hover': {
            background: theme.palette.primary.hover,
        },
    },
    SaveComponentButtonTypeSaveError: {
        background: theme.palette.red.main,
        '&:hover': {
            background: theme.palette.red.hover,
        },
    },
    SaveComponentButtonTypeCancel: {
        background: theme.palette.lightGrey.dark,
        color: `${theme.palette.typography.main} !important`,
    },
    SaveComponentButtonTypeDelete: {
        background: theme.palette.red.main,
        '&:hover': {
            background: theme.palette.red.hover,
        },
    },
    SaveComponentErrorMessageContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '1rem',
        width: 'fit-content',
        maxWidth: '100%',
        margin: '0 auto',
        padding: '1.2rem 1.5rem',
        borderRadius: '1rem',
        background: theme.palette.red.ultraVeryLight,
    },
    SaveComponentErrorMessageIcon: {
        color: theme.palette.red.main,
        flexShrink: 0,
        marginTop: '0.1rem',
    },
    SaveComponentErrorMessage: {
        color: theme.palette.red.main,
        whiteSpace: 'pre-line',
        textAlign: 'left',
    },
    SaveComponentBlockedNavigationDialogContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        paddingBottom: '3rem',
    },
    SaveComponentBlockedNavigationDialogMessagecontainer: {
        '& .MuiTypography-root': {
            fontSize: '1.2rem',
        },
    },
    SaveComponentBlockedNavigationDialogContentSeparator: {
        width: '100%',
        height: '2px',
        borderRadius: '100px',
        background: theme.palette.lightGrey.dark,
    },
    SaveComponentBlockedNavigationDialogContentButtonContainer: {
        padding: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1.5rem',
    },
}))
